interface Props {
  label: string;
  enabled: boolean;
  onToggle: (enableds: any) => Promise<void>;
}

function NotificationRow({ label, enabled, onToggle }: Props) {
  return (
    <div className="row profile-row">
      <div className="column-1">{label}</div>
      <div className="column-2">{enabled ? "Enabled" : "Disabled"}</div>
      <div className="column-3">
        {/* TODO: this should be a semantic checkbox */}
        <div onClick={onToggle} className={`switch ${enabled}`}>
          <div className="circle" />
        </div>
      </div>
    </div>
  );
}

export default NotificationRow;
